import Types from 'prop-types';
export var NumOrStringPropType = Types.oneOfType([Types.string, Types.number]);
export var ComponentPropType = Types.oneOfType([Types.func, Types.string]);
export var OptionPropType = Types.shape({
  value: NumOrStringPropType,
  label: NumOrStringPropType
});
export var SelectModelPropType = Types.shape({
  state: Types.shape({
    optionsAll: Types.arrayOf(OptionPropType),
    multi: Types.bool,
    isLoading: Types.bool,
    options: Types.arrayOf(OptionPropType),
    value: Types.string,
    selected: Types.oneOfType([OptionPropType, Types.arrayOf(OptionPropType)]),
    index: NumOrStringPropType,
    isOpen: Types.bool
  }),
  actions: Types.shape({
    setValue: Types.func,
    clearValue: Types.func,
    pushIndexedToSelected: Types.func,
    pushSelected: Types.func,
    popSelected: Types.func,
    clearSelected: Types.func,
    openMenu: Types.func,
    closeMenu: Types.func,
    setIndex: Types.func,
    incrementIndex: Types.func,
    decrementIndex: Types.func
  }),
  helpers: Types.shape({
    pluckLabel: Types.func,
    pluckValue: Types.func
  })
});